import React, { useState, useEffect } from "react";
import _ from "lodash";
import moment from "moment";
import "moment-timezone";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table/css/react-bootstrap-table.css";
import DatePicker from "react-datepicker";
import { Modal, Button } from "react-bootstrap";
import { AddPO } from "../../partial/addPO";
import DepositModal from "../../partial/DepositModal";
import DepositAlert from "../../partial/DepositAlert";
import CompletionPhotosModal from "../../partial/CompletionPhotosModal";
import "react-datepicker/dist/react-datepicker.css";
import StarRatingComponent from "react-star-rating-component";
import { convertFromUTC } from "../../../util/convert_timezone";
import dateService from "../../../services/dateService";
import PaymentProgressModal from "../../partial/PaymentProgressModal";
import { HTTPService } from "./../../../services/httpService";
import { canTransferJob } from "../../../util/jobUtils";
import { getScheduleNotification } from "../../../util/dateDisplayUtils";
import { isMultiLocation, isMobileLocation } from "../../../util/locationUtils";
import { isPlaceholderVin, isUncollectedVin, isMarine } from "../../../util/assetType";
import { marineAttrsOf } from "../../../util/marineService";
import { canDeliver, isSettledOffline } from "../../../util/deliverGate";
import MobileAppointmentForm from "../../partial/MobileAppointmentForm";
import TechPicker from "../../common/TechPicker";
import TenderTiles from "../../common/TenderTiles";
import PayOnlinePanel from "../../common/PayOnlinePanel";
import CheckoutDrawer from "../../common/CheckoutDrawer";
import ProductPicker from "../../common/ProductPicker";
import { formatProductLabel, formatPrefixedProductLabel } from "../../../util/productLabel";
import { formatDuration } from "../../../util/durationDisplay";

const API = new HTTPService();

// Constants
const USER_ACCESS_ASSIST = "ASSIST";
const REQUEST_STATES = {
  NEW: "new",
  ANSWERED: "answered",
  SCHEDULED: "scheduled",
  STARTED: "started",
  RECEIVED: "received",
  FINISHED: "finished",
  PAID: "paid",
  COLLECTED: "collected"
};

const USER_TYPES = {
  DEALER: "dealer",
  INSTALLER: "installer"
};

const REQUEST_TYPES = {
  DEALER: "dealer",
  INSTALLER: "installer"
};

const SERVICE_STATES = {
  NEW: "new",
  STARTED: "started"
};

const WORK_STATUSES = ['booked', 'pending', 'started'];

// Utility Functions
const formatCurrency = (amount) => {
  return isNaN(amount) ? "$0.00" : "$" + amount.toFixed(2);
};

const ScheduleNotification = ({ request, calendarDays }) => {
//console.log("ScheduleNotification called with request:", request, calendarDays);
  const notification = getScheduleNotification(request, calendarDays);
//console.log("ScheduleNotification returns:", notification);
  
  if (!notification) return null;
  
  const alertClass = notification.type === 'warning' ? 'alert-warning' : 'alert-info';
  
  return (
    <div className={`alert ${alertClass} mx-3 mb-3`} style={{ fontSize: '14px' }}>
      {notification.icon} {notification.message}
    </div>
  );
};

// Helper function to fetch signed URL for contract viewing
const fetchSignedUrl = async (requestId) => {
  const newTab = window.open("", "_blank");
  try {
    const response = await API.get(`signedURL/?requestId=${requestId}`);
    if (response.data.signedUrl) {
      newTab.location.href = response.data.signedUrl;
    } else {
      console.error("No signed URL found.");
      alert("Error accessing contract.");
    }
  } catch (error) {
    console.error("Error fetching signed URL:", error);
    alert("Error accessing contract.");
  }
};

const formatServiceAmount = (service, discount = 0) => {
  // If service_discount is already stored separately, use it
  const serviceDiscount = service.service_discount || discount || 0;
  const amount = parseFloat(service.service_amount) - parseFloat(serviceDiscount);
  return formatCurrency(amount);
};

const formatDateString = (date) => {
  if (!date) return 'Not set';
  return dateService.displayDate(date, "ddd, MMM Do, YYYY");
};

const prepareServiceData = (services) => {
  return services.map(service => {
    // Don't modify service_amount - let the formatter handle discount display
    return {
      ...service,
      service_amount: parseFloat(service.service_amount), // Keep original amount
      service_discount: parseFloat(service.service_discount || 0)
    };
  });
};
const prepareOffersData = (offers) => {
  return offers.map(offer => ({
    ...offer,
    startDateString: formatDateString(offer.startDate),
    installerName: offer.installerName
  }));
};

const handleCheckIn = async (request, routerHistory) => {

  console.log ("here's the requst for checkin", request)
  try {

      routerHistory.push(`/requests/${request.requestId}/checkin`);
/*
    // Check if check-in wizard is enabled for this installer
    const installer = this.state.installer || this.props.installer;

    if (installer && installer.checkin_wizard_enabled) {
      // Use new check-in wizard
      this.props.history.push(`/requests/${requestId}/checkin`);
    } else {
      // Fallback to existing simple flow (if you have one)
      alert('Check-in wizard not enabled for this account');
    }
      */
  } catch (error) {
    console.error('Error starting check-in:', error);
    alert('Error starting check-in. Please try again.');
  }
};

// Add this enhanced column definition for dealers near the existing getServiceColumns function
const getDealerServiceColumns = () => [
  {
    dataField: "description",
    text: "Service",
    headerAlign: "center",
    formatter: (cell, row) => {
      const cat = row.product_id ? 'Product - ' : (row.service_category ? `${row.service_category} - ` : '');
      return `${cat}${cell || '-'}`;
    }
  },
{ 
  dataField: "service_amount", 
  text: "Specialist Cost", 
  formatter: (cell, row) => formatServiceAmount(row)
},  { 
    dataField: "retail_price", 
    text: "Customer Price", 
    formatter: (cell, row) => {
      // Use retail_price if available, otherwise fall back to service_amount
      const retailPrice = cell || row.service_amount || 0;
      return formatCurrency(parseFloat(retailPrice));
    }
  },
{
  dataField: "margin",
  text: "Margin",
  formatter: (cell, row) => {
    const retailPrice = parseFloat(row.retail_price || row.service_amount || 0);
    const serviceDiscount = parseFloat(row.service_discount || 0);
    const specialistCost = parseFloat(row.service_amount || 0) - serviceDiscount; // ✅ Discounted
    const margin = retailPrice - specialistCost;
    return (
      <span className={margin >= 0 ? "text-success" : "text-danger"}>
        {formatCurrency(margin)}
      </span>
    );
  }
},
  { dataField: "service_duration", text: "Duration", formatter: (cell) => formatDuration(cell) ?? '-' }
];

const getCustomServiceColumns = (onSelectProduct, categoryHasProducts) => [
  {
    dataField: "custom_description",
    text: "Service",
    headerAlign: "center",
    formatter: (cell, row) => {
      // Check if service has items (new model)
      const hasItems = row.items && row.items.length > 0;
      const materialItems = hasItems ? row.items.filter(i => !i.type || i.type === 'material') : [];
      const allItemsAssigned = materialItems.length > 0 && materialItems.every(i => i.recommended_product_id);

      // Legacy: check if recommended product is set (service-level)
      const hasRecommendedProduct = !hasItems && row.recommended_product_id && row.recommended_product_name;
      const recommendedProductDisplay = hasRecommendedProduct
        ? formatPrefixedProductLabel(row, 'recommended_product')
        : null;

      const cat = row.product_id ? 'Product - ' : (row.service_category ? `${row.service_category} - ` : '');

      return (
        <div>
          <div className="d-flex align-items-start justify-content-between">
            <div className="flex-grow-1">
              <span>{cat}{cell || row.description || '-'}</span>

              {/* Show per-item product list — only items with a product assigned */}
              {hasItems && materialItems.filter(i => i.recommended_product_id).map(item => (
                <div key={item.id} className="small mt-1 text-success">
                  <i className="fa-sharp fa-regular fa-check mr-1"></i>
                  <strong>{item.label}:</strong> {formatPrefixedProductLabel(item, 'recommended_product')}
                </div>
              ))}

              {/* Legacy fallback: show service-level recommended product */}
              {hasRecommendedProduct && (
                <div className="small text-success mt-1">
                  <i className="fa-sharp fa-regular fa-check mr-1"></i>
                  <strong>Use:</strong> {recommendedProductDisplay}
                </div>
              )}
            </div>

            {/* Cube button - always opens ServiceItemsModal */}
            {onSelectProduct && (
              <button
                type="button"
                className={`btn btn-sm ml-2 ${allItemsAssigned ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelectProduct(row);
                }}
                title={allItemsAssigned ? 'All items assigned' : 'Manage service items'}
                style={{ padding: '2px 6px', flexShrink: 0 }}
              >
                <i className={`fa-sharp fa-regular ${allItemsAssigned ? 'fa-check' : 'fa-cube'}`}></i>
              </button>
            )}
          </div>
        </div>
      );
    }
  },
  {
    dataField: "service_amount",
    text: "Amount",
    formatter: (cell, row) => formatServiceAmount(row)
  },
  { dataField: "service_duration", text: "Duration", formatter: (cell) => formatDuration(cell) ?? '-' }
];

const getServiceStatusColumns = () => [
  {
    dataField: "description",
    text: "Service",
    headerAlign: "center",
    formatter: (cell, row) => {
      const cat = row.product_id ? 'Product - ' : (row.service_category ? `${row.service_category} - ` : '');
      return `${cat}${cell || '-'}`;
    }
  },
  { dataField: "Status", text: "Status" }
];

const getOfferColumns = () => [
  { dataField: "installerName", text: "Installer" },
  { dataField: "startDateString", text: "Date to Start" }
];

const getWorkServiceColumns = (technicians, onAssignTechnician, onEditInstructions, requestId, onShowMaterials, onSelectProduct, categoryHasProducts, onSplitAssignment) => [
  {
    dataField: "custom_description",
    text: "Service",
    headerAlign: "center",
    formatter: (cell, row) => {
      // Check if actual materials have been collected
      const hasMaterials = row.materials && row.materials.length > 0;

      // Check if service has items (new model)
      const hasItems = row.items && row.items.length > 0;
      const materialItems = hasItems ? row.items.filter(i => !i.type || i.type === 'material') : [];
      const allItemsAssigned = materialItems.length > 0 && materialItems.every(i => i.recommended_product_id);

      // Legacy: check if recommended product is set (service-level)
      const hasRecommendedProduct = !hasItems && row.recommended_product_id && row.recommended_product_name;
      const recommendedProductDisplay = hasRecommendedProduct
        ? formatPrefixedProductLabel(row, 'recommended_product')
        : null;

      // Get materials display text
      const getMaterialsDisplay = () => {
        if (row.materials && row.materials.length > 0) {
          const label = formatProductLabel(row.materials[0]);
          if (label) return label;
        }
        return 'Materials recorded';
      };

      const cat = row.product_id ? 'Product - ' : (row.service_category ? `${row.service_category} - ` : '');

      return (
        <div>
          <div className="d-flex align-items-start justify-content-between">
            <div className="flex-grow-1">
              <span>{cat}{cell || row.description || '-'}</span>

              {/* Show what was actually used (materials collected) */}
              {hasMaterials && (
                <div className="small text-info mt-1">
                  <i className="fa-sharp fa-regular fa-cubes mr-1"></i>
                  <strong>Used:</strong> {getMaterialsDisplay()}
                </div>
              )}

              {/* Show per-item product list — only items with a product assigned */}
              {!hasMaterials && hasItems && materialItems.filter(i => i.recommended_product_id).map(item => (
                <div key={item.id} className="small mt-1 text-success">
                  <i className="fa-sharp fa-regular fa-check mr-1"></i>
                  <strong>{item.label}:</strong> {formatPrefixedProductLabel(item, 'recommended_product')}
                </div>
              ))}

              {/* Legacy fallback: show service-level recommended product */}
              {!hasMaterials && hasRecommendedProduct && (
                <div className="small text-success mt-1">
                  <i className="fa-sharp fa-regular fa-check mr-1"></i>
                  <strong>Use:</strong> {recommendedProductDisplay}
                </div>
              )}
            </div>

            {/* Right-justified button area */}
            <div style={{ flexShrink: 0 }}>
              {/* Materials used - show cubes icon (takes priority) */}
              {hasMaterials && (
                <button
                  type="button"
                  className="btn btn-sm btn-link p-0 ml-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onShowMaterials) onShowMaterials(row);
                  }}
                  title="View materials used"
                >
                  <i className="fa-sharp fa-regular fa-cubes text-info"></i>
                </button>
              )}

              {/* Cube button - always opens ServiceItemsModal when no materials collected */}
              {!hasMaterials && onSelectProduct && (
                <button
                  type="button"
                  className={`btn btn-sm ml-2 ${allItemsAssigned ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelectProduct(row);
                  }}
                  title={allItemsAssigned ? 'All items assigned' : 'Manage service items'}
                  style={{ padding: '2px 6px' }}
                >
                  <i className={`fa-sharp fa-regular ${allItemsAssigned ? 'fa-check' : 'fa-cube'}`}></i>
                </button>
              )}
            </div>
          </div>
        </div>
      );
    }
  },
  {
    dataField: "service_amount",
    text: "Amount",
    formatter: (cell, row) => formatServiceAmount(row)
  },
  { dataField: "service_duration", text: "Duration", formatter: (cell) => formatDuration(cell) ?? '-' },
  { dataField: "service_state", text: "State" },
  // Technician assignment column - only show if technicians exist
  ...(technicians && technicians.length > 0 ? [{
    dataField: "assigned_technician_id",
    text: "Lead tech",
    formatter: (cell, row) => {
      const ta = row.tech_assignment;
      const totalTaskCount = ta?.total_task_count ?? 0;
      // Splitting is only meaningful with 2+ steps and 2+ techs.
      const splitEligible = totalTaskCount >= 2 && technicians.length >= 2;

      // Override the picker's displayed label to reflect per-step state.
      // 'single' → tech name (cell holds lead id); 'mixed'/'partial' → synthetic
      // label so the row honestly reflects what's been assigned across steps.
      const isMixed = ta?.effective_state === 'mixed';
      const isPartial = ta?.effective_state === 'partial';
      const displayValue = isMixed || isPartial ? null : cell;
      const displayPlaceholder = isMixed
        ? 'Multiple techs'
        : isPartial
        ? 'Partially assigned'
        : 'Unassigned';

      let caption = null;
      if (ta) {
        if (isPartial) {
          const assigned = totalTaskCount - (ta.unassigned_task_count ?? 0);
          caption = `${assigned} of ${totalTaskCount} steps assigned`;
        } else if (isMixed) {
          caption = `${ta.techs?.length ?? 0} techs across ${totalTaskCount} steps`;
        }
        // No caption for the unassigned case: the picker already reads
        // "Unassigned" directly above it, so a second line saying the same thing
        // is noise. The two captions above survive because they say something
        // the picker cannot — how MANY steps, across how many techs.
      }

      const openSplit = (e) => {
        if (e) e.stopPropagation();
        if (onSplitAssignment) onSplitAssignment(row);
      };

      return (
        <div>
          <div className="d-flex align-items-center">
            <TechPicker
              technicians={technicians}
              value={displayValue}
              placeholder={displayPlaceholder}
              onChange={(techId) => onAssignTechnician(requestId, row.service_id, techId, row.id)}
              onSplit={splitEligible ? () => openSplit() : undefined}
            />
            {/* Instructions icon - only show if assigned */}
            {cell && (
              <button
                type="button"
                className="btn btn-sm btn-link p-0 ml-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onEditInstructions(row);
                }}
                title={row.technician_instructions ? "Edit instructions" : "Add instructions"}
              >
                <i className={`fa-sharp fa-regular fa-sticky-note ${row.technician_instructions ? 'text-info' : 'text-muted'}`}></i>
              </button>
            )}
          </div>
          {caption && (
            <small
              className="text-muted d-block mt-1"
              style={{ cursor: splitEligible ? 'pointer' : 'default', textDecoration: splitEligible ? 'underline' : 'none' }}
              onClick={splitEligible ? openSplit : undefined}
            >
              {caption}
            </small>
          )}
        </div>
      );
    }
  }] : [])
];

// Basic work columns without assignment (for technicians viewing their own work)
const getBasicWorkServiceColumns = (onShowMaterials) => [
  {
    dataField: "custom_description",
    text: "Service",
    headerAlign: "center",
    formatter: (cell, row) => {
      const hasMaterials = row.materials && row.materials.length > 0;
      const cat = row.product_id ? 'Product - ' : (row.service_category ? `${row.service_category} - ` : '');
      return (
        <div className="d-flex align-items-center">
          <span>{cat}{cell || row.description || '-'}</span>
          {hasMaterials && (
            <button
              type="button"
              className="btn btn-sm btn-link p-0 ml-2"
              onClick={(e) => {
                e.stopPropagation();
                if (onShowMaterials) onShowMaterials(row);
              }}
              title="View materials used"
            >
              <i className="fa-sharp fa-regular fa-cubes text-info"></i>
            </button>
          )}
        </div>
      );
    }
  },
  {
    dataField: "service_amount",
    text: "Amount",
    formatter: (cell, row) => formatServiceAmount(row)
  },
  { dataField: "service_duration", text: "Duration", formatter: (cell) => formatDuration(cell) ?? '-' },
  { dataField: "service_state", text: "State" }
];
// Helper Functions
const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

const calculateExistingCommitments = (calendarDays, currentRequestId = null) => {
  let existingCommitmentDates = [];
  const today = moment().startOf('day');
  
  for (let c = 0; c < calendarDays.length; c++) {
    const workDate = moment(calendarDays[c].workDate).startOf('day');
    const isCurrentJob = currentRequestId && calendarDays[c].requestId === currentRequestId;
    
    // Only include commitments from today forward, with active status, excluding current job
    if (WORK_STATUSES.includes(calendarDays[c].workStatus) && 
        workDate.isSameOrAfter(today) &&
        !isCurrentJob) {
      existingCommitmentDates.push(
        new Date(workDate.format("MMMM D, YYYY"))
      );
    }
  }
  
  return existingCommitmentDates;
};

const prepareServiceStatusData = (services) => {
  return services.map(service => ({
    service_id: service.service_id,
    service_category: service.service_category,
    description: service.description,
    Status: _.capitalize(service.service_state)
  }));
};

// Reusable Components
const ServiceTable = ({ data, columns, keyField = "service_id", selectRow, rowEvents }) => {
  const tableProps = {
    keyField,
    data,
    columns
  };
  
  // Only add selectRow if it's provided and not null
  if (selectRow) {
    tableProps.selectRow = selectRow;
  }
  
  // Only add rowEvents if it's provided and not null
  if (rowEvents) {
    tableProps.rowEvents = rowEvents;
  }
  
  return (
    <div className="table-responsive jv-bt-table">
      <BootstrapTable {...tableProps} />
    </div>
  );
};

// REPLACE the existing AvailabilityAlert component in requestimateState.jsx

const AvailabilityAlert = ({ availability, calendarDays, requestId, selectedDate }) => {
  if (!availability) return null;
  
  const selectedDateStr = moment(selectedDate).format("YYYY-MM-DD");
  const suggestedDateStr = moment(availability.nextStart).format("YYYY-MM-DD");
  const isUserOverride = selectedDateStr !== suggestedDateStr;
  
  // Check for conflicts on selected date
  const conflictsOnSelectedDate = calendarDays?.filter(entry => 
    moment(entry.workDate).format("YYYY-MM-DD") === selectedDateStr && 
    ['booked', 'started'].includes(entry.workStatus) &&
    entry.requestId !== requestId
  ).length || 0;
  
  const getAlertType = () => {
    if (conflictsOnSelectedDate > 0) return 'warning';
    if (availability.canFit !== false) return 'success';
    return 'info';
  };
  
  const getCapacityMessage = () => {
    if (conflictsOnSelectedDate > 0) {
      return `⚠️ ${conflictsOnSelectedDate} confirmed job(s) on this date - schedule adjustment may be needed`;
    }
    
    if (availability.canFit !== false) {
      return "✅ Fits within normal capacity";
    }
    
    return "ℹ️ May require working over normal capacity";
  };
  
  return (
    <div className="form-row justify-content-md-center mb-3">
      <div className="col-md-8">
        <div className={`alert alert-${getAlertType()}`}>
          <strong><i className="fa-sharp fa-regular fa-calendar mr-1"></i> Selected Date:</strong> {moment(selectedDate).format("MMM DD, YYYY")}
          {availability.totalJobDays > 0 && (
            <span> ({formatDuration(availability.totalJobDays)})</span>
          )}
          
          <div style={{ margin: "8px 0" }}>
            {getCapacityMessage()}
          </div>
          
          {/* Show suggestion if different from selection */}
          {isUserOverride && (
            <div style={{ color: "var(--color-text-secondary)", fontSize: "14px" }}>
              💡 Suggested date: {moment(availability.nextStart).format("MMM DD, YYYY")} 
              (optimal fit)
            </div>
          )}
                    
          {/* Capacity details if available */}
          {availability.availableSlots !== undefined && (
            <div style={{ fontSize: "12px", color: "var(--color-text-secondary)", marginTop: "5px" }}>
              Capacity: {availability.availableSlots} of {availability.availableSlots + (availability.existingJobs || 0)} slots available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// REPLACE the DatePickerSection component in requestimateState.jsx with this:

const DatePickerSection = ({
  sDate,
  minDate,
  maxDate,
  exclude,
  existingCommitmentDates,
  onStartDateChange,
  label = "Pick Start Date",
  closedDays = [],  // Day-of-week numbers where location is closed (0=Sunday)
  blockedDates = [] // Specific dates that are blocked (holidays, vacations) as strings 'YYYY-MM-DD'
}) => {
  // Convert blockedDates strings to Date objects for excludeDates prop
  const blockedDateObjects = React.useMemo(() =>
    blockedDates.map(dateStr => moment(dateStr).toDate()),
    [blockedDates]
  );

  // Combine exclude prop with blocked dates
  const allExcludedDates = React.useMemo(() =>
    [...(exclude || []), ...blockedDateObjects],
    [exclude, blockedDateObjects]
  );

  // Memoize the date picker to prevent unnecessary re-renders
  /* eslint-disable react-hooks/exhaustive-deps */
  const memoizedDatePicker = React.useMemo(() => (
    <DatePicker
      selected={sDate}
      onChange={onStartDateChange}
      minDate={minDate}
      maxDate={maxDate}
      excludeDates={allExcludedDates}
      highlightDates={existingCommitmentDates}
      filterDate={(date) => {
        // Filter out days the location is closed (recurring weekly closures)
        const dayOfWeek = moment(date).day(); // 0=Sunday, 1=Monday, etc.
        return !closedDays.includes(dayOfWeek);
      }}
      dateFormat="MMMM d, yyyy"
      className="form-control"
      placeholderText="Click to select date"
      showPopperArrow={false}
      popperClassName="date-picker-popper"
      calendarClassName="date-picker-calendar"
    />
  ), [
    moment(sDate).format("YYYY-MM-DD"), // Use string comparison for dates
    moment(minDate).format("YYYY-MM-DD"),
    maxDate ? moment(maxDate).format("YYYY-MM-DD") : null,
    allExcludedDates.length, // Track all excluded dates
    existingCommitmentDates.length, // Just track array length
    closedDays.length, // Track closed days changes
    onStartDateChange
  ]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <div className="mt-4 mb-4">
      <div className="row">
        <div className="col">
          <form className="form-row justify-content-md-center">
            <div className="form-group col-lg-2 text-center">
              <label className="bold">{label}</label>
            </div>
            <div className="form-group col-lg-4">
              <div className="input-group">
                {memoizedDatePicker}
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i className="fa-sharp fa-regular fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ onClick, className, disabled = false, children, userAccess }) => {
  if (userAccess === USER_ACCESS_ASSIST) return null;
  
  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

/**
 * The asset's identifier line — "VIN : ..." for a vehicle, "HIN : ..." for a craft.
 *
 * A craft has no VIN. It carries a synthetic `BT`-prefixed placeholder purely so the
 * request->asset join keeps working, and printing that placeholder shows the shop a
 * fake VIN it can neither verify nor use. Its real identifier is the Hull
 * Identification Number, captured at check-in.
 *
 * This exists as ONE component because the identifier is rendered in two places (the
 * in-progress card and the finished card) that had already drifted apart — the
 * finished one guarded the placeholder and the in-progress one did not, so the same
 * craft showed a fake VIN during the job and "Not Collected" after it. Two copies of
 * this branching is how that happens; there is one.
 */
const AssetIdentifier = ({ request, hin, fieldKey, copiedField, copyToClipboard }) => {
  const marine = isMarine(request.vin);
  const label = marine ? 'HIN' : 'VIN';

  // The HIN arrives from /requests/:id/checkin/status, which the parent fans out
  // on select. It is NOT on the getinstallerestimates row that becomes `request` —
  // that query has no marine_attributes join — so the explicit prop is the real
  // source here. `marineAttrsOf` is the fallback for callers whose request row DOES
  // carry it (fullrequest does), so this works either way.
  const value = marine ? (hin || marineAttrsOf(request).hin || '') : request.vin;

  // A craft with no HIN yet reads the same as a vehicle with no VIN: not collected.
  const missing = marine ? !value : isUncollectedVin(request.vin);
  if (missing) return <>{label} : <b>Not Collected</b></>;

  return (
    <>
      {label} :{" "}
      <span
        onClick={() => copyToClipboard(value, fieldKey)}
        style={{ cursor: 'pointer', borderBottom: '1px dashed var(--color-border-strong)', position: 'relative' }}
        title={`Click to copy ${label}`}
      >
        {copiedField === fieldKey && (
          <span style={{ position: 'absolute', top: '-1.5em', left: '50%', transform: 'translateX(-50%)', fontSize: '0.7rem', whiteSpace: 'nowrap', color: 'var(--color-success)' }}>
            Copied to Clipboard
          </span>
        )}
        {value}
        <i className="fa-sharp fa-regular fa-copy text-muted ml-2" style={{ fontSize: '0.8rem' }}></i>
      </span>
    </>
  );
};

const VehicleInfo = ({ request, scheduledDate }) => {
  // Not system-generated (NV / OT / BT) and not empty.
  const hasValidVin = !isPlaceholderVin(request.vin);

  // scheduledDate is already constructed in the location's timezone by the
  // parent (see scheduledStartDate). For mobile bookings the moment carries
  // a real time-of-day; for fixed shop it's midnight at the location.
  let scheduledLabel;
  if (scheduledDate) {
    const hasTime = scheduledDate.hour() !== 0 || scheduledDate.minute() !== 0;
    scheduledLabel = scheduledDate.format(
      hasTime ? "dddd, MMMM D, YYYY [at] h:mm A" : "dddd, MMMM D, YYYY"
    );
  } else {
    scheduledLabel = convertFromUTC(request.availableDate).format("dddd, MMMM D, YYYY");
  }

  return (
    <div className="mt-4 mb-4">
      <h4 className="text-primary mb-3">
        <i className="fa-sharp fa-regular fa-calendar-alt mr-2"></i>
        Scheduled: {scheduledLabel}
      </h4>
      {hasValidVin && (
        <p className="text-muted">
          <strong>VIN:</strong> {request.vin}
        </p>
      )}
    </div>
  );
};


// Technician Instructions Modal Component
const TechnicianInstructionsModal = ({
  show,
  onHide,
  service,
  onSave,
  saving
}) => {
  const [instructions, setInstructions] = useState(service?.technician_instructions || '');

  // Reset instructions when service changes
  React.useEffect(() => {
    setInstructions(service?.technician_instructions || '');
  }, [service]);

  const handleSave = () => {
    onSave(service?.service_id, instructions);
  };

  // Build the service display string with category
  const serviceDisplayCat = service?.product_id ? 'Product' : service?.service_category;
  const serviceDisplay = serviceDisplayCat
    ? `${serviceDisplayCat} - ${service?.custom_description || service?.description}`
    : service?.custom_description || service?.description;

  // Build recommended product display
  const hasRecommendedProduct = service?.recommended_product_id && service?.recommended_product_name;
  const recommendedProductDisplay = hasRecommendedProduct
    ? formatPrefixedProductLabel(service, 'recommended_product')
    : null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Technician Instructions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label className="font-weight-bold">
            Service: {serviceDisplay}
          </label>
          {hasRecommendedProduct && (
            <div className="text-success mb-2">
              <i className="fa-sharp fa-regular fa-check mr-1"></i>
              <strong>Recommended Product:</strong> {recommendedProductDisplay}
            </div>
          )}
          <textarea
            className="form-control"
            rows={4}
            value={instructions}
            onChange={(e) => setInstructions(e.target.value)}
            placeholder="Add instructions for the technician..."
            disabled={saving}
          />
          <small className="form-text text-muted">
            These notes will be visible to the assigned technician in their My Work view.
          </small>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={saving}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={saving}>
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              Saving...
            </>
          ) : (
            'Save Instructions'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Dealer Reschedule Modal Component
const DealerRescheduleModal = ({
  show,
  onHide,
  request,
  onConfirm,
  availableDate,
  dueDate,
  onAvailableDateChange,
  onDueDateChange,
  locationTz,
}) => {
  // Handle available date change with smart due date adjustment
  const handleAvailableDateChange = (date) => {
    onAvailableDateChange(date);

    // If the new available date is after the current due date,
    // automatically update due date to match available date
    if (dueDate && moment(date).isAfter(moment(dueDate))) {
      onDueDateChange(date);
    }
  };

  // "Today" anchored to the LOCATION's timezone — EDT viewer of an HST
  // dealer uses HST's calendar.
  const today = moment.tz(locationTz || moment.tz.guess()).startOf('day').toDate();

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Reschedule Job</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="reschedule-modal-container">
          <div className="alert alert-info">
            <strong>Current Request Dates:</strong>
            <br />
            Available Date: {convertFromUTC(request.availableDate).format("MM/DD/YYYY")}
            <br />
            Due Date: {convertFromUTC(request.dueDate).format("MM/DD/YYYY")}
          </div>

          <div className="form-group">
            <label htmlFor="availableDate" className="font-weight-bold">
              Available Date <span className="text-danger">*</span>
            </label>
            <DatePicker
              id="availableDate"
              selected={availableDate}
              onChange={handleAvailableDateChange}
              minDate={today}
              dateFormat="MM/dd/yyyy"
              className="form-control"
              placeholderText="Select available date"
            />
            <small className="form-text text-muted">
              When the vehicle will be available for the specialist to start work
            </small>
          </div>

          <div className="form-group mt-3">
            <label htmlFor="dueDate" className="font-weight-bold">
              Due Date <span className="text-danger">*</span>
            </label>
            <DatePicker
              id="dueDate"
              selected={dueDate}
              onChange={onDueDateChange}
              minDate={availableDate || today}
              dateFormat="MM/dd/yyyy"
              className="form-control"
              placeholderText="Select due date"
            />
            <small className="form-text text-muted">
              Deadline for completing the work
            </small>
          </div>

          {availableDate && dueDate && moment(dueDate).isBefore(availableDate) && (
            <div className="alert alert-danger mt-3">
              Due date cannot be before available date
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="warning"
          onClick={onConfirm}
          disabled={!availableDate || !dueDate || moment(dueDate).isBefore(availableDate)}
        >
          Update Schedule
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const RequestimateState = (props) => {
  // Detect if mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const {
    userType,
    typeId,
    userAccess,
    userRole,
    installer,
    request,
    services,
    notes,
    displayedList,
    offers,
    routerHistory,
    invoice,
    calendarDays,
    startDate,
    onStartDateChange,
    rowSelected,
    onDelete,
    selectedInstaller,
    selectedService,
    onAccept,
    onAcceptEstimate,
    onCompleteEstimate,
    onReject,
    onAssign,
    onReschedule,
    onDealerReschedule,
    canDealerReschedule,
    onStart,
    onFinish,
    onComplete,
    submitting = false,
    onSelectService,
    onSelectInstaller,
    showDepositModal,
    onShowDepositModal,
    onHideDepositModal,
    onSaveDeposit,
    onCreateDepositInvoice,
    onResendDepositInvoice,
    onOpenDepositInvoice,
    onEdit,
    reviewScore,
    onReviewScoreChange,
    onSettle,
    onReview,
    selectedPay,
    onCollect,
    onAddProductLine,
    onRemoveProductLine,
    onUpdateProductQty,
    addingProductId,
    onDeliver,
    showSwipe,
    closeSwipe,
    showPO,
    closePO,
    onAddPO,
    onPO,
    availability,
    // NEW PROPS for progress modal:
    paymentState,
    paymentError,
    onRetryPayment,
    onCancelTerminal,
    onTransferLocation,

    // Collect path (TenderTiles) props
    collectedPayments,
    isProcessingSplitPayment,
    isConfirmingSplitPayment,
    splitPaymentError,
    remainingBalance,
    payOnlineInvoiceId,
    onPayOnlinePaid,
    onPayOnlineDone,
    showInvoiceLinkModal,
    currentInvoiceLink,
    onCloseInvoiceLinkModal,
    onSendQuote,

    // Technician Assignment Props
    technicians,
    onAssignTechnician,
    onSplitAssignment,
    onSaveInstructions,
    savingInstructions,

    // Product Selection Props
    categoryHasProducts,
    onSelectProduct,

    // Multi-location Props
    locations,

    // CarFax Data Props
    checkinOdometerReading,
    checkinPlate,
    checkinHin,
    checkinCarfaxOptOut,
    onCarfaxOptOut,

    // Draft invoice (Invoice at Payment) props
    isMaterializing,
    onSendDealerInvoice,
    onVoidInvoice,
    offlineSettlement,
  } = props;

  // Filter technicians to those assigned to the request's location
  const requestLocId = request?.location_id || request?.locationId;
  const locationTechnicians = (technicians || []).filter(tech => {
    if (!requestLocId || requestLocId === 0 || requestLocId === '0') return true; // unclaimed — show all
    const techLocId = tech.location_id || tech.locationId;
    return !techLocId || String(techLocId) === String(requestLocId);
  });

  // Local state for completion photos modal
  const [showCompletionPhotos, setShowCompletionPhotos] = useState(false);
  const [showCheckoutDrawer, setShowCheckoutDrawer] = useState(false);
  const [showProductPicker, setShowProductPicker] = useState(false);
  const [showDealerCollect, setShowDealerCollect] = useState(false);

  // Auto-close the checkout drawer once the (Stripe) invoice settles.
  useEffect(() => {
    if (showCheckoutDrawer && invoice && invoice.paid) {
      setShowCheckoutDrawer(false);
    }
  }, [invoice, showCheckoutDrawer]);

  // Copy-to-clipboard state and helper
  const [copiedField, setCopiedField] = useState(null);
  const copyToClipboard = (value, fieldName) => {
    if (!value) return;
    navigator.clipboard.writeText(value).then(() => {
      setCopiedField(fieldName);
      setTimeout(() => setCopiedField(null), 1500);
    }).catch(() => {
      const textarea = document.createElement('textarea');
      textarea.value = value;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopiedField(fieldName);
      setTimeout(() => setCopiedField(null), 1500);
    });
  };


  // Handler to open service items modal (via parent)
  const handleOpenProductSelection = (service) => {
    if (onSelectProduct) {
      onSelectProduct(service);
    }
  };

  // Local state for technician instructions modal
  const [showInstructionsModal, setShowInstructionsModal] = useState(false);
  const [editingService, setEditingService] = useState(null);

  // Local state for materials view modal
  const [showMaterialsViewModal, setShowMaterialsViewModal] = useState(false);
  const [materialsViewService, setMaterialsViewService] = useState(null);

  // Handler for opening instructions modal
  const handleEditInstructions = (service) => {
    setEditingService(service);
    setShowInstructionsModal(true);
  };

  // Handler for saving instructions
  const handleSaveInstructions = (serviceId, instructions) => {
    onSaveInstructions(request.requestId, serviceId, instructions);
    setShowInstructionsModal(false);
    setEditingService(null);
  };

  // Handler for showing materials used
  const handleShowMaterials = (service) => {
    setMaterialsViewService(service);
    setShowMaterialsViewModal(true);
  };

  // Local state for dealer reschedule modal
  const [showDealerRescheduleModal, setShowDealerRescheduleModal] = useState(false);
  const [rescheduleAvailableDate, setRescheduleAvailableDate] = useState(null);
  const [rescheduleDueDate, setRescheduleDueDate] = useState(null);

  // Mobile booking — appointment_start (moment with time) when scheduling a
  // mobile-location job. Lifted here so the "Book Job" handler can read it
  // and the slot-pick component can write it. Initialized from the request's
  // existing scheduledStart when present (covers the reschedule-back-to-NEW
  // case where the prior slot is the natural starting point).
  //
  // TZ wrinkle: mysql2 with timezone:'Z' returns DATETIME values labeled as
  // UTC, but the server stores them as wall-clock at the location. Extract
  // the wall-clock via moment.utc, then re-anchor in the location's TZ so
  // the form sees the right date + time-of-day.
  const initialLocationTz = props.currentLocation?.timezone || moment.tz.guess();
  const [appointmentStart, setAppointmentStart] = useState(() => {
    // Appointment slots apply ONLY to mobile locations (driven by
    // MobileAppointmentForm). Fixed shops book via the date picker (startDate).
    // Seeding this from scheduledStart for a fixed shop is wrong: scheduledStart
    // holds the *proposed* offer date even before booking, nothing updates it
    // when the user picks a new date, and handleAcceptEstimate would then treat
    // the booking as a mobile slot and overwrite the picked date with this stale
    // original date.
    if (!isMobileLocation(props.currentLocation)) return null;
    if (!request?.scheduledStart) return null;
    const wallClock = moment.utc(request.scheduledStart);
    if (!wallClock.isValid()) return null;
    return moment.tz(
      wallClock.format('YYYY-MM-DD HH:mm:ss'),
      'YYYY-MM-DD HH:mm:ss',
      initialLocationTz
    );
  });

  const handleCompletionPhotosSuccess = () => {
    // Refresh the page or reload request data after successful upload
    window.location.reload();
  };

  // Early returns for empty state
  if (isEmpty(request)) {
    return null;
  }

  const check = displayedList.filter(
    (item) => item.requestId === request.requestId
  );

  if (check.length === 0) {
    return null;
  }

  // Prepare data
  const displayOffers = prepareOffersData(offers);

  const noteText = notes.length > 0 && notes[0].note_text.length > 1
    ? notes[0].note_text 
    : "None";

  // Filter offers for dealer display
  if (userType === USER_TYPES.DEALER) {
    const filteredOffers = offers.filter(
      (offer) => offer.currentStatus === "accepted"
    );
    displayOffers.splice(0, displayOffers.length, ...prepareOffersData(filteredOffers));
  }

  // Scheduled dates come from request_offered (via server JOIN). Server stores
  // wall-clock-at-location in DATETIME; mysql2 (timezone:'Z') hands it back as
  // a UTC-labelled ISO but the value is wall-clock. Extract wall-clock via
  // moment.utc().format(), then re-anchor in the location's TZ — same pattern
  // calendar.jsx and the appointmentStart init use. Using moment.tz(iso, tz)
  // here would (wrongly) treat the value as a real UTC instant and shift it.
  const locationTz = props.currentLocation?.timezone || moment.tz.guess();
  const scheduledStartDate = request.scheduledStart
    ? moment.tz(
        moment.utc(request.scheduledStart).format('YYYY-MM-DD HH:mm:ss'),
        'YYYY-MM-DD HH:mm:ss',
        locationTz
      )
    : moment.tz(
        moment.utc(request.availableDate).format('YYYY-MM-DD HH:mm:ss'),
        'YYYY-MM-DD HH:mm:ss',
        locationTz
      );

// Date calculations - stabilized with string comparisons.
// All "today" anchors use the LOCATION's timezone so EDT viewers of an
// HST-located request see HST's calendar, not their browser's.
const startDateStr = moment(startDate).format("YYYY-MM-DD");
const todayStr = moment.tz(locationTz).format("YYYY-MM-DD");

// Universal minimum date (can't book in the past) - use string comparison first
let sDate;
if (startDateStr < todayStr) {
  sDate = moment.tz(locationTz).startOf('day').toDate();
} else {
  sDate = moment(startDate).toDate();
}

// Dealer dueDate is informational — AvailabilityAlert surfaces slips.
// Don't hard-cap the picker; installers need to reschedule past the
// dealer's window when the original date can't be hit.
let maxDate = null;

// Use consistent date objects to prevent re-renders
const minDate = moment.tz(locationTz).startOf('day').toDate();

// Remove the excessive logging that was causing console spam
/* console.log("🎯 Final date calculation:", {
  userSelected: startDateStr,
  finalDate: moment(sDate).format("YYYY-MM-DD"),
  jobType: request.requestType
});*/

  //console.log("User Type : ", userType);
  //console.log("Request Type : ", request.requestType);
  //console.log("Current State : ", request.currentState);
  //console.log("Assigned To : ", request.assignedTo);

  // Job services setup
  const thisJobServices = Array.from(
    calendarDays.filter((day) => day.requestId === request.requestId)
  );
  const thisJob = _.orderBy(thisJobServices, "serviceId", "asc");

  // Calculate exclude dates and commitments
const existingCommitmentDates = calculateExistingCommitments(calendarDays);

  // Invoice processing
  const workingInvoice = JSON.parse(JSON.stringify(invoice));

  //************************************************************************
  //*******************  Dealer Group (full dealer flow) *******************
  //************************************************************************
  // Dealer-group users previously hit a read-only early-return here that
  // suppressed every action button. That gate has been removed: group users
  // now fall through to the same per-state dealer rendering below and get the
  // standard dealer action buttons (assign, reschedule, delete, review, …),
  // regardless of group vs. single-dealership scope.

  //************************************************************************
  //***************************  Dealer Pages ******************************
  //************************************************************************

if (request.currentState === REQUEST_STATES.NEW && userType === USER_TYPES.DEALER) {
  const services_ = Array.from(services);
  // Check if this dealer is configured to require contracts
  const dealerRequiresContracts = props.company?.customer_contract === 'Y';

  // Check if dealer can reschedule
  const rescheduleCheck = canDealerReschedule ? canDealerReschedule(request) : { canReschedule: false };

  const handleRescheduleClick = () => {
    // Initialize modal with current dates
    setRescheduleAvailableDate(moment(request.availableDate).toDate());
    setRescheduleDueDate(moment(request.dueDate).toDate());
    setShowDealerRescheduleModal(true);
  };

  const handleRescheduleConfirm = () => {
    onDealerReschedule(request, rescheduleAvailableDate, rescheduleDueDate);
    setShowDealerRescheduleModal(false);
  };

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          {/* Enhanced service table showing both specialist cost and customer retail price */}
          <ServiceTable
            data={services_}
            columns={getDealerServiceColumns()}
          />

          {/* Action Buttons - including contract button inline */}
          <div className="jv-btn-group-spaced">
            {/* Contract Button - Only if dealer requires contracts */}
            {dealerRequiresContracts && (
              request.contract_url ? (
                <ActionButton
                  onClick={() => fetchSignedUrl(request.requestId)}
                  className="jv-btn jv-btn-tertiary"
                  userAccess={userAccess}
                >
                  View Contract
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => window.location.href = `/contract/${request.requestId}`}
                  className="jv-btn jv-btn-primary"
                  userAccess={userAccess}
                >
                  Create Contract
                </ActionButton>
              )
            )}

            {/* Reschedule Button */}
            {rescheduleCheck.canReschedule && (
              <ActionButton
                onClick={handleRescheduleClick}
                className="jv-btn jv-btn-secondary"
                userAccess={userAccess}
              >
                Reschedule
              </ActionButton>
            )}

            <ActionButton
              onClick={() => onDelete(request)}
              className="jv-btn jv-btn-danger"
              userAccess={userAccess}
            >
              Delete
            </ActionButton>
          </div>
        </div>
      </div>

      {/* Dealer Reschedule Modal */}
      <DealerRescheduleModal
        show={showDealerRescheduleModal}
        onHide={() => setShowDealerRescheduleModal(false)}
        request={request}
        onConfirm={handleRescheduleConfirm}
        availableDate={rescheduleAvailableDate}
        dueDate={rescheduleDueDate}
        onAvailableDateChange={setRescheduleAvailableDate}
        onDueDateChange={setRescheduleDueDate}
        locationTz={locationTz}
      />
    </React.Fragment>
  );
}

// Answered request for Dealer - WITH CONTRACT OPTION
if (request.currentState === REQUEST_STATES.ANSWERED && userType === USER_TYPES.DEALER) {
  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    bgColor: "var(--color-bg-inset)",
    onClick: (e, row, rowIndex) => {
      onSelectInstaller(row);
    },
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      onSelectInstaller(row);
    },
  };

  // Check if this dealer is configured to require contracts
  const dealerRequiresContracts = props.company?.customer_contract === 'Y';

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          <h5 className="card-title">
            Approve the work for the specialist to start
          </h5>
          <ServiceTable 
            data={displayOffers} 
            columns={getOfferColumns()}
            keyField="installerId"
            selectRow={selectRow}
            rowEvents={rowEvents}
          />
          
          {/* Action Buttons - including contract button inline */}
          <div className="jv-btn-group-spaced">
            {/* Contract Button - Only if dealer requires contracts */}
            {dealerRequiresContracts && (
              request.contract_url ? (
                <ActionButton
                  onClick={() => fetchSignedUrl(request.requestId)}
                  className="jv-btn jv-btn-tertiary"
                  userAccess={userAccess}
                >
                  View Contract
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => window.location.href = `/contract/${request.requestId}`}
                  className="jv-btn jv-btn-primary"
                  userAccess={userAccess}
                >
                  Create Contract
                </ActionButton>
              )
            )}

            <ActionButton
              onClick={() => onAssign(request, selectedInstaller)}
              className="jv-btn jv-btn-primary"
              disabled={!selectedInstaller}
              userAccess={userAccess}
            >
              Assign
            </ActionButton>

            <span className="jv-btn-group-divider" />

            <ActionButton
              onClick={() => onDelete(request)}
              className="jv-btn jv-btn-danger"
              userAccess={userAccess}
            >
              Delete
            </ActionButton>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

// RECEIVED state for Dealer - with reschedule option
  if (request.currentState === REQUEST_STATES.RECEIVED && userType === USER_TYPES.DEALER) {
    const services_ = prepareServiceStatusData(services);

    // Check if dealer can reschedule
    const rescheduleCheck = canDealerReschedule ? canDealerReschedule(request) : { canReschedule: false };

    const handleRescheduleClick = () => {
      // Initialize modal with current dates
      setRescheduleAvailableDate(moment(request.availableDate).toDate());
      setRescheduleDueDate(moment(request.dueDate).toDate());
      setShowDealerRescheduleModal(true);
    };

    const handleRescheduleConfirm = () => {
      onDealerReschedule(request, rescheduleAvailableDate, rescheduleDueDate);
      setShowDealerRescheduleModal(false);
    };

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <ScheduleNotification request={request} calendarDays={calendarDays} />
            <ServiceTable
              data={services_}
              columns={getServiceStatusColumns()}
            />

            {/* Reschedule Button */}
            {rescheduleCheck.canReschedule && (
              <div className="jv-btn-group-spaced">
                <ActionButton
                  onClick={handleRescheduleClick}
                  className="jv-btn jv-btn-secondary"
                  userAccess={userAccess}
                >
                  Reschedule
                </ActionButton>
              </div>
            )}
          </div>
        </div>

        {/* Dealer Reschedule Modal */}
        <DealerRescheduleModal
          show={showDealerRescheduleModal}
          onHide={() => setShowDealerRescheduleModal(false)}
          request={request}
          onConfirm={handleRescheduleConfirm}
          availableDate={rescheduleAvailableDate}
          dueDate={rescheduleDueDate}
          onAvailableDateChange={setRescheduleAvailableDate}
          onDueDateChange={setRescheduleDueDate}
          locationTz={locationTz}
        />
      </React.Fragment>
    );
  }

// Multiple states for Dealer showing service status (STARTED and FINISHED - no reschedule allowed)
  const dealerStatusStates = [ REQUEST_STATES.STARTED, REQUEST_STATES.FINISHED];
  if (dealerStatusStates.includes(request.currentState) && userType === USER_TYPES.DEALER) {
    const services_ = prepareServiceStatusData(services);

    //console.log("RequestimateState : service  :", services)
    //console.log("RequestimateState : service history :", history)

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <ScheduleNotification request={request} calendarDays={calendarDays} />
            <ServiceTable
              data={services_}
              columns={getServiceStatusColumns()}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
  
if (request.currentState === REQUEST_STATES.SCHEDULED && userType === USER_TYPES.DEALER) {
  const services_ = prepareServiceStatusData(services);
  const dealerRequiresContracts = props.company?.customer_contract === 'Y';

  // Check if dealer can reschedule
  const rescheduleCheck = canDealerReschedule ? canDealerReschedule(request) : { canReschedule: false };

  const handleRescheduleClick = () => {
    // Initialize modal with current dates
    setRescheduleAvailableDate(moment(request.availableDate).toDate());
    setRescheduleDueDate(moment(request.dueDate).toDate());
    setShowDealerRescheduleModal(true);
  };

  const handleRescheduleConfirm = () => {
    onDealerReschedule(request, rescheduleAvailableDate, rescheduleDueDate);
    setShowDealerRescheduleModal(false);
  };

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
<ScheduleNotification request={request} calendarDays={calendarDays} />
          <ServiceTable
            data={services_}
            columns={getServiceStatusColumns()}
          />

          {/* Contract functionality - available until work starts */}
          {dealerRequiresContracts && (
            <div>
              {!request.contract_url && (
                <div className="alert alert-warning mb-3">
                  <i className="fa-sharp fa-regular fa-exclamation-triangle"></i>
                  <strong> Contract Required:</strong> Work cannot begin until customer contract is created and signed.
                </div>
              )}

              {request.contract_url && (
                <div className="alert alert-success mb-3">
                  <i className="fa-sharp fa-regular fa-check-circle"></i>
                  <strong> Contract Ready:</strong> Customer contract is complete. Work can proceed.
                </div>
              )}
            </div>
          )}

          <div className="jv-btn-group-spaced">
            {/* Contract Action Button */}
            {dealerRequiresContracts && (
              request.contract_url ? (
                <ActionButton
                  onClick={() => fetchSignedUrl(request.requestId)}
                  className="jv-btn jv-btn-tertiary"
                  userAccess={userAccess}
                >
                  View Contract
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => window.location.href = `/contract/${request.requestId}`}
                  className="jv-btn jv-btn-primary"
                  userAccess={userAccess}
                >
                  Create Contract
                </ActionButton>
              )
            )}

            {/* Reschedule Button */}
            {rescheduleCheck.canReschedule && (
              <ActionButton
                onClick={handleRescheduleClick}
                className="jv-btn jv-btn-secondary"
                userAccess={userAccess}
              >
                Reschedule
              </ActionButton>
            )}
          </div>
        </div>
      </div>

      {/* Dealer Reschedule Modal */}
      <DealerRescheduleModal
        show={showDealerRescheduleModal}
        onHide={() => setShowDealerRescheduleModal(false)}
        request={request}
        onConfirm={handleRescheduleConfirm}
        availableDate={rescheduleAvailableDate}
        dueDate={rescheduleDueDate}
        onAvailableDateChange={setRescheduleAvailableDate}
        onDueDateChange={setRescheduleDueDate}
        locationTz={locationTz}
      />
    </React.Fragment>
  );
}

  // Finished job for Dealer - Review
  if (request.currentState === REQUEST_STATES.COLLECTED && userType === USER_TYPES.DEALER) {
    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <h5 className="card-title">Rate the installer work</h5>
            <div className="col-lg-12">
              <StarRatingComponent
                name="rate1"
                starCount={5}
                value={reviewScore}
                onStarClick={onReviewScoreChange}
                starColor="var(--color-warning)"
                emptyStarColor="var(--color-border-strong)"
                renderStarIcon={(index, value) => (
                  <i className={index <= value ? 'fa-sharp fa-solid fa-star' : 'fa-sharp fa-regular fa-star'} />
                )}
              />
            </div>
            <div className="jv-btn-group-spaced">
              <ActionButton
                onClick={() => onReview(request)}
                className="jv-btn jv-btn-primary"
                disabled={!reviewScore}
                userAccess={userAccess}
              >
                Submit Review
              </ActionButton>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }


  //************************************************************************
  //***************************  Installer Pages ***************************
  //************************************************************************

  // New Request display for Installer Estimate
// UPDATED LOGIC - Replace existing conditions

// 1. DISCOVERY JOBS (assigned_to = 0) - Require CLAIM action
const isDiscoveryJob = request.currentState === REQUEST_STATES.NEW && 
  userType === USER_TYPES.INSTALLER && 
  request.requestType === REQUEST_TYPES.DEALER && 
  request.assignedTo === 0;

// 2. DIRECT ASSIGNMENTS (assigned_to = specialist_id) - Just need BOOK action  
const isDirectAssignment = request.currentState === REQUEST_STATES.NEW && 
  userType === USER_TYPES.INSTALLER && 
  request.requestType === REQUEST_TYPES.DEALER && 
  request.assignedTo === parseInt(typeId); // Directly assigned to this specialist

// 3. RETAIL JOBS (installer creates their own) - Just need BOOK action
const isRetailJob = request.currentState === REQUEST_STATES.NEW && 
  userType === USER_TYPES.INSTALLER && 
  request.requestType === REQUEST_TYPES.INSTALLER;

// COMBINED logic for jobs that just need booking (not claiming)
const isInstallerNewRequest = isRetailJob || isDirectAssignment;

if (isInstallerNewRequest) {
  const services_ = prepareServiceData(services);
  const showTransferOption = canTransferJob(request, { installer_id: parseInt(typeId) }, userRole);

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          <ServiceTable
            data={services_}
            columns={getCustomServiceColumns(handleOpenProductSelection, categoryHasProducts)}
          />
        </div>
{isMobileLocation(props.currentLocation) ? (
  <MobileAppointmentForm
    currentStep={5}
    currentLocation={props.currentLocation}
    customerLat={request?.customer_address_lat ?? request?.latitude}
    customerLng={request?.customer_address_long ?? request?.longitude}
    services={services}
    appointmentStart={appointmentStart}
    onAppointmentChange={setAppointmentStart}
    excludeRequestId={request?.scheduledStart ? request.requestId : null}
  />
) : (
  <>
    <AvailabilityAlert
      availability={availability}
      calendarDays={calendarDays}
      requestId={request.requestId}
      selectedDate={sDate}
      jobType={request.requestType}
    />
    <DatePickerSection
      sDate={sDate}
      minDate={minDate}
      maxDate={maxDate}
      exclude={[]}
      existingCommitmentDates={existingCommitmentDates}
      onStartDateChange={onStartDateChange}
      label="Pick Start Date"
      closedDays={availability?.closedDays || []}
      blockedDates={availability?.blockedDates || []}
    />
  </>
)}

        <div className="row justify-content-center">
          <div className="col-12">
            <div className="jv-btn-group-spaced">
              {/* Group 1: Work the Estimate */}
              {request.requestType === 'installer' && (() => {
                const quoteSentAt = request.quoteSentAt || request.quote_sent_at;
                const quoteAcceptedAt = request.quoteAcceptedAt || request.quote_accepted_at;
                if (!quoteAcceptedAt) {
                  return (
                    <ActionButton
                      onClick={() => onSendQuote(request)}
                      className="jv-btn jv-btn-primary"
                      userAccess={userAccess}
                    >
                      {quoteSentAt ? 'Resend Estimate' : 'Send Estimate'}
                    </ActionButton>
                  );
                }
                return null;
              })()}
              <ActionButton
                onClick={() => onEdit(request)}
                className="jv-btn jv-btn-secondary"
                userAccess={userAccess}
              >
                Edit
              </ActionButton>
              {request.requestType === 'installer' && (
                <ActionButton
                  onClick={() => onShowDepositModal(request)}
                  className="jv-btn jv-btn-tertiary"
                  userAccess={userAccess}
                >
                  Set Deposit
                </ActionButton>
              )}

              <div className="jv-btn-group-divider">{'\u00A0'}</div>

              {/* Group 2: Move it Forward */}
              <ActionButton
                onClick={() => onAcceptEstimate(request, startDate, appointmentStart)}
                className="jv-btn jv-btn-primary"
                userAccess={userAccess}
                disabled={isMobileLocation(props.currentLocation) && !appointmentStart}
              >
                Book Job
              </ActionButton>
              {showTransferOption && isMultiLocation(locations) && (
                <ActionButton
                  onClick={() => onTransferLocation(request)}
                  className="jv-btn jv-btn-secondary"
                  userAccess={userAccess}
                >
                  Transfer
                </ActionButton>
              )}
              <ActionButton
                onClick={() => onCompleteEstimate(request, startDate)}
                className="jv-btn jv-btn-secondary"
                disabled={submitting}
                userAccess={userAccess}
              >
                Job Completed
              </ActionButton>

              <div className="jv-btn-group-divider">{'\u00A0'}</div>

              {/* Group 3: Remove */}
              <ActionButton
                onClick={() => onDelete(request)}
                className="jv-btn jv-btn-danger"
                userAccess={userAccess}
              >
                Delete
              </ActionButton>
            </div>

            {/* Deposit modal */}
            <DepositModal
              show={showDepositModal}
              onHide={onHideDepositModal}
              request={request}
              onSaveDeposit={onSaveDeposit}
            />
          </div>
        </div>
      </div>

    </React.Fragment>
  );
}

  // New request for Installer user for a dealer request (unassigned)

  if (isDiscoveryJob) {
    const services_ = prepareServiceData(services);

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <ServiceTable
              data={services_}
              columns={getCustomServiceColumns(handleOpenProductSelection, categoryHasProducts)}
            />
{isMobileLocation(props.currentLocation) ? (
  <MobileAppointmentForm
    currentStep={5}
    currentLocation={props.currentLocation}
    customerLat={request?.customer_address_lat ?? request?.latitude}
    customerLng={request?.customer_address_long ?? request?.longitude}
    services={services}
    appointmentStart={appointmentStart}
    onAppointmentChange={setAppointmentStart}
    excludeRequestId={request?.scheduledStart ? request.requestId : null}
  />
) : (
  <>
    <AvailabilityAlert
      availability={availability}
      calendarDays={calendarDays}
      requestId={request.requestId}
      selectedDate={sDate}
      jobType={request.requestType}
    />
    <DatePickerSection
      sDate={sDate}
      minDate={minDate}
      maxDate={maxDate}
      exclude={[]}
      existingCommitmentDates={existingCommitmentDates}
      onStartDateChange={onStartDateChange}
      label="Pick Start Date"
      closedDays={availability?.closedDays || []}
      blockedDates={availability?.blockedDates || []}
    />
  </>
)}
            <div className="jv-btn-group-spaced">
              <ActionButton
                onClick={() => onAccept(request, sDate, appointmentStart)}
                className="jv-btn jv-btn-primary"
                userAccess={userAccess}
                disabled={isMobileLocation(props.currentLocation) && !appointmentStart}
              >
                Claim
              </ActionButton>

              <span className="jv-btn-group-divider" />

              <ActionButton
                onClick={() => onReject(request)}
                className="jv-btn jv-btn-danger"
                userAccess={userAccess}
              >
                Reject
              </ActionButton>
            </div>
          </div>
        </div>

      </React.Fragment>
    );
  }

  // Installer receiving car from dealer/customer
  if (request.currentState === REQUEST_STATES.SCHEDULED && userType === USER_TYPES.INSTALLER) {
    const services_ = prepareServiceData(services);
    const hasTechnicians = locationTechnicians && locationTechnicians.length > 0;

    // Columns for check-in page - Service, Amount, Duration, and optionally Assigned To
    const getCheckinServiceColumns = () => [
      {
        dataField: "custom_description",
        text: "Service",
        headerAlign: "center",
        formatter: (cell, row) => {
          // Check if service has items (new model)
          const hasItems = row.items && row.items.length > 0;
          const materialItems = hasItems ? row.items.filter(i => !i.type || i.type === 'material') : [];
          const allItemsAssigned = materialItems.length > 0 && materialItems.every(i => i.recommended_product_id);

          // Legacy: check if recommended product is set (service-level)
          const hasRecommendedProduct = !hasItems && row.recommended_product_id && row.recommended_product_name;
          const recommendedProductDisplay = hasRecommendedProduct
            ? formatPrefixedProductLabel(row, 'recommended_product')
            : null;

          const cat = row.product_id ? 'Product - ' : (row.service_category ? `${row.service_category} - ` : '');

          return (
            <div>
              <div className="d-flex align-items-start justify-content-between">
                <div className="flex-grow-1">
                  <span>{cat}{cell || row.description || '-'}</span>

                  {/* Show per-item product list — only items with a product assigned */}
                  {hasItems && materialItems.filter(i => i.recommended_product_id).map(item => (
                    <div key={item.id} className="small mt-1 text-success">
                      <i className="fa-sharp fa-regular fa-check mr-1"></i>
                      <strong>{item.label}:</strong> {formatPrefixedProductLabel(item, 'recommended_product')}
                    </div>
                  ))}

                  {/* Legacy fallback: show service-level recommended product */}
                  {hasRecommendedProduct && (
                    <div className="small text-success mt-1">
                      <i className="fa-sharp fa-regular fa-check mr-1"></i>
                      <strong>Use:</strong> {recommendedProductDisplay}
                    </div>
                  )}
                </div>

                {/* Cube button - always opens ServiceItemsModal */}
                {onSelectProduct && (
                  <button
                    type="button"
                    className={`btn btn-sm ml-2 ${allItemsAssigned ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenProductSelection(row);
                    }}
                    title={allItemsAssigned ? 'All items assigned' : 'Manage service items'}
                    style={{ padding: '2px 6px', flexShrink: 0 }}
                  >
                    <i className={`fa-sharp fa-regular ${allItemsAssigned ? 'fa-check' : 'fa-cube'}`}></i>
                  </button>
                )}
              </div>
            </div>
          );
        }
      },
      {
        dataField: "service_amount",
        text: "Amount",
        formatter: (cell, row) => formatServiceAmount(row)
      },
      { dataField: "service_duration", text: "Duration", formatter: (cell) => formatDuration(cell) ?? '-' },
      // Technician assignment column - only show if technicians exist
      ...(hasTechnicians ? [{
        dataField: "assigned_technician_id",
        text: "Lead tech",
        formatter: (cell, row) => {
          const ta = row.tech_assignment;
          const totalTaskCount = ta?.total_task_count ?? 0;
          const splitEligible = totalTaskCount >= 2 && locationTechnicians.length >= 2;
          const isMixed = ta?.effective_state === 'mixed';
          const isPartial = ta?.effective_state === 'partial';
          const displayValue = isMixed || isPartial ? null : cell;
          const displayPlaceholder = isMixed
            ? 'Multiple techs'
            : isPartial
            ? 'Partially assigned'
            : 'Unassigned';
          const openSplit = (e) => {
            if (e) e.stopPropagation();
            if (onSplitAssignment) onSplitAssignment(row);
          };
          return (
            <div>
              <div className="d-flex align-items-center">
                <TechPicker
                  technicians={locationTechnicians}
                  value={displayValue}
                  placeholder={displayPlaceholder}
                  onChange={(techId) => onAssignTechnician(request.requestId, row.service_id, techId, row.id)}
                  onSplit={splitEligible ? () => openSplit() : undefined}
                />
                {/* Instructions icon - only show if assigned */}
                {cell && (
                  <button
                    type="button"
                    className="btn btn-sm btn-link p-0 ml-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditInstructions(row);
                    }}
                    title={row.technician_instructions ? "Edit instructions" : "Add instructions"}
                  >
                    <i className={`fa-sharp fa-regular fa-sticky-note ${row.technician_instructions ? 'text-info' : 'text-muted'}`}></i>
                  </button>
                )}
              </div>
            </div>
          );
        }
      }] : [])
    ];

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            {/* Services table with assignment - above scheduled date */}
            <ServiceTable
              data={services_}
              columns={getCheckinServiceColumns()}
            />
          </div>

          {/* Deposit banner — before VehicleInfo */}
          <DepositAlert request={request} onOpenInvoice={onOpenDepositInvoice} />

          <VehicleInfo
            request={request}
            scheduledDate={scheduledStartDate}
          />
          <div className="jv-btn-group-spaced">
            <ActionButton
              onClick={() => handleCheckIn(request, routerHistory)}
              className="jv-btn jv-btn-primary"
              userAccess={userAccess}
            >
              Check In
            </ActionButton>

            <span className="jv-btn-group-divider" />

            {request.requestType === 'installer' && (
              <ActionButton
                onClick={() => onShowDepositModal(request)}
                className="jv-btn jv-btn-tertiary"
                userAccess={userAccess}
              >
                Set Deposit
              </ActionButton>
            )}

            <ActionButton
              onClick={() => onReschedule(request)}
              className="jv-btn jv-btn-secondary"
              userAccess={userAccess}
            >
              Reschedule
            </ActionButton>
            <ActionButton
              onClick={() => onEdit(request)}
              className="jv-btn jv-btn-secondary"
              userAccess={userAccess}
            >
              Edit
            </ActionButton>

            <span className="jv-btn-group-divider" />

            <ActionButton
              onClick={() => onDelete(request)}
              className="jv-btn jv-btn-danger"
              userAccess={userAccess}
            >
              Delete
            </ActionButton>
          </div>

          {/* Deposit Modal — post-booking: writes the amount AND creates+sends the
              deposit invoice (onCreateDepositInvoice), deduped inside the modal. */}
          <DepositModal
            show={showDepositModal}
            onHide={onHideDepositModal}
            request={request}
            onSaveDeposit={onSaveDeposit}
            onCreateDepositInvoice={onCreateDepositInvoice}
            onResendDepositInvoice={onResendDepositInvoice}
          />
        </div>

        {/* Technician Instructions Modal - for SCHEDULED state */}
        <TechnicianInstructionsModal
          show={showInstructionsModal}
          onHide={() => {
            setShowInstructionsModal(false);
            setEditingService(null);
          }}
          service={editingService}
          onSave={handleSaveInstructions}
          saving={savingInstructions}
        />

        {/* Materials View Modal - for SCHEDULED state */}
        <Modal
          show={showMaterialsViewModal}
          onHide={() => {
            setShowMaterialsViewModal(false);
            setMaterialsViewService(null);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fa-sharp fa-regular fa-cubes mr-2"></i>
              Materials Used
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {materialsViewService && (
              <div>
                <div className="mb-3">
                  <strong>{materialsViewService.service_category}</strong>
                  {materialsViewService.custom_description && (
                    <span className="text-muted"> - {materialsViewService.custom_description}</span>
                  )}
                </div>

                {materialsViewService.materials && materialsViewService.materials.length > 0 ? (
                  <div className="materials-list">
                    {materialsViewService.materials.map((material, index) => (
                      <div key={index} className="p-2 mb-2 border rounded">
                        <div className="font-weight-bold">
                          {material.brand && <span>{material.brand} - </span>}
                          {material.product_name}
                        </div>
                        {material.quantity_used && (
                          <div className="text-muted small">
                            Quantity: {material.quantity_used} {material.unit_code || ''}
                          </div>
                        )}
                        {material.barcode && (
                          <div className="text-muted small">
                            Roll: <code>{material.barcode}</code>
                          </div>
                        )}
                        {material.lot_number && (
                          <div className="text-muted small">
                            Lot: <code>{material.lot_number}</code>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No materials tracked.</p>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setShowMaterialsViewModal(false);
              setMaterialsViewService(null);
            }}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }

  // Service work states for Installer
  const installerWorkStates = [REQUEST_STATES.RECEIVED, REQUEST_STATES.STARTED];
  if (installerWorkStates.includes(request.currentState) && userType === USER_TYPES.INSTALLER) {
    const selectRow = {
      mode: "radio",
      clickToSelect: true,
      style: { bgColor: "var(--color-bg-inset)" },
      onSelect: (e, row, rowIndex) => {
        onSelectService(rowIndex);
      },
    };

    const services_ = prepareServiceData(services);

    // Determine which columns to use based on whether technicians exist at this location
    const hasTechnicians = locationTechnicians && locationTechnicians.length > 0;
    const workColumns = hasTechnicians
      ? getWorkServiceColumns(locationTechnicians, onAssignTechnician, handleEditInstructions, request.requestId, handleShowMaterials, handleOpenProductSelection, categoryHasProducts, onSplitAssignment)
      : getBasicWorkServiceColumns(handleShowMaterials);

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <div className="row text-center">
              <div className="col text-center">
                <h5 className="card-title">
                  <AssetIdentifier
                    request={request}
                    hin={checkinHin}
                    fieldKey="vin"
                    copiedField={copiedField}
                    copyToClipboard={copyToClipboard}
                  />
                </h5>
              </div>
            </div>
            {/* CarFax data missing warning — retail jobs only, when not opted out.
                Marine is exempt: a craft has no odometer and no licence plate, and no
                marine work is submitted to CarFax at all (the server excludes it at
                the query). Without this the banner demands two fields that can never
                be filled, on a job that was never going to CarFax. */}
            {request.requestType === 'installer' && !checkinCarfaxOptOut && !isMarine(request.vin) && (
              !checkinOdometerReading || !checkinPlate
            ) && (
              <div className="alert alert-warning text-left mx-3 mt-2 mb-0 d-flex justify-content-between align-items-center" style={{ fontSize: '0.9rem' }}>
                <div>
                  <i className="fa-sharp fa-regular fa-exclamation-triangle mr-2"></i>
                  <strong>CarFax data needed before completion:</strong>{' '}
                  {[
                    !checkinOdometerReading && 'Odometer reading',
                    !checkinPlate && 'Plate state'
                  ].filter(Boolean).join(', ')}
                </div>
                {onCarfaxOptOut && (
                  <button
                    className="btn btn-sm btn-outline-secondary ml-3"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={() => {
                      if (window.confirm('Disable CarFax reporting for this job?')) {
                        onCarfaxOptOut(request.requestId);
                      }
                    }}
                  >
                    <i className="fa-sharp fa-regular fa-times mr-1"></i>
                    Disable CarFax
                  </button>
                )}
              </div>
            )}

            {/* Deposit status — RECEIVED only. Work can't start until the deposit is
                paid (Start is disabled below), so it never needs to show once started. */}
            {request.currentState === REQUEST_STATES.RECEIVED && (
              <DepositAlert request={request} onOpenInvoice={onOpenDepositInvoice} blockedNote />
            )}

            <div className="mt-4 mb-4">
              <ServiceTable
                data={services_}
                columns={workColumns}
                selectRow={selectRow}
              />
              <form>
                <div className="bg-light rounded p-3 mb-3 shadow-sm">
                  <div className="jv-btn-group-spaced">
                    <ActionButton
                      onClick={() => onStart(request, thisJob, services_[selectedService])}
                      className="jv-btn jv-btn-primary"
                      disabled={!rowSelected || (rowSelected && services_[selectedService].service_state !== SERVICE_STATES.NEW) || (request.depositAmount > 0 && !request.depositIsPaid)}
                      userAccess={userAccess}
                    >
                      Start
                    </ActionButton>
                    <ActionButton
                      onClick={() => onFinish(request, thisJob, services_[selectedService])}
                      className="jv-btn jv-btn-primary"
                      disabled={submitting || !rowSelected || (rowSelected && services_[selectedService].service_state !== SERVICE_STATES.STARTED)}
                      userAccess={userAccess}
                    >
                      Finish
                    </ActionButton>
                  </div>
                </div>
                <div className="jv-btn-group-spaced">
                  {request.currentState === REQUEST_STATES.RECEIVED && request.requestType === 'installer' && (
                    <ActionButton
                      onClick={() => onShowDepositModal(request)}
                      className="jv-btn jv-btn-tertiary"
                      userAccess={userAccess}
                    >
                      Set Deposit
                    </ActionButton>
                  )}
                  <ActionButton
                    onClick={() => onEdit(request)}
                    className="jv-btn jv-btn-secondary"
                    userAccess={userAccess}
                  >
                    Edit
                  </ActionButton>
                  {noteText !== "None" && (
                    <button
                      type="button"
                      onClick={() => alert(noteText)}
                      className="jv-btn jv-btn-tertiary"
                    >
                      Notes
                    </button>
                  )}

                  <div className="jv-btn-group-divider">{'\u00A0'}</div>

                  <ActionButton
                    onClick={() => onComplete(request, services_)}
                    className="jv-btn jv-btn-primary"
                    disabled={submitting}
                    userAccess={userAccess}
                  >
                    Complete
                  </ActionButton>

                  <div className="jv-btn-group-divider">{'\u00A0'}</div>
                  <ActionButton
                    onClick={() => onDelete(request)}
                    className="jv-btn jv-btn-danger"
                    userAccess={userAccess}
                  >
                    Delete
                  </ActionButton>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Technician Instructions Modal */}
        <TechnicianInstructionsModal
          show={showInstructionsModal}
          onHide={() => {
            setShowInstructionsModal(false);
            setEditingService(null);
          }}
          service={editingService}
          onSave={handleSaveInstructions}
          saving={savingInstructions}
        />

        {/* Materials View Modal */}
        <Modal
          show={showMaterialsViewModal}
          onHide={() => {
            setShowMaterialsViewModal(false);
            setMaterialsViewService(null);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fa-sharp fa-regular fa-cubes mr-2"></i>
              Materials Used
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {materialsViewService && (
              <div>
                <div className="mb-3">
                  <strong>{materialsViewService.service_category}</strong>
                  {materialsViewService.custom_description && (
                    <span className="text-muted"> - {materialsViewService.custom_description}</span>
                  )}
                </div>

                {materialsViewService.materials && materialsViewService.materials.length > 0 ? (
                  <div className="materials-list">
                    {materialsViewService.materials.map((material, index) => (
                      <div key={index} className="p-2 mb-2 border rounded">
                        <div className="font-weight-bold">
                          {material.brand && <span>{material.brand} - </span>}
                          {material.product_name}
                        </div>
                        {material.quantity_used && (
                          <div className="text-muted small">
                            Quantity: {material.quantity_used} {material.unit_code || ''}
                          </div>
                        )}
                        {material.barcode && (
                          <div className="text-muted small">
                            Roll: <code>{material.barcode}</code>
                          </div>
                        )}
                        {material.lot_number && (
                          <div className="text-muted small">
                            Lot: <code>{material.lot_number}</code>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No materials tracked.</p>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setShowMaterialsViewModal(false);
              setMaterialsViewService(null);
            }}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Deposit Modal — post-booking: writes the amount AND creates+sends the
            deposit invoice (onCreateDepositInvoice), deduped inside the modal. */}
        <DepositModal
          show={showDepositModal}
          onHide={onHideDepositModal}
          request={request}
          onSaveDeposit={onSaveDeposit}
          onCreateDepositInvoice={onCreateDepositInvoice}
          onResendDepositInvoice={onResendDepositInvoice}
        />
      </React.Fragment>
    );
  }

  // A dealer job that was delivered (collected) but has NO invoice — the
  // Financials "Void & Replace" outcome. Pickups keeps the row for exactly this
  // case; it needs the pickup screen so Check Out → Send invoice can create and
  // send the replacement. Nothing here writes current_state.
  const isInvoiceRecovery =
    request.currentState === REQUEST_STATES.COLLECTED
    && request.requestType === REQUEST_TYPES.DEALER
    && !request.invoiceId;

  // Customer/Dealer picks up car from Installer
  if ((request.currentState === REQUEST_STATES.FINISHED
       || request.currentState === REQUEST_STATES.PAID
       || isInvoiceRecovery)
      && userType === USER_TYPES.INSTALLER) {
    // UNIFIED PICKUP SCREEN for installer jobs


    let PO = "Not Yet";
    if ((Object.keys(workingInvoice?.metadata || {})).length > 3 && workingInvoice?.metadata?.PO > "") {
      PO = Object.values(workingInvoice.metadata.PO);
    } else if (request.poNumber || request.po_number) {
      PO = request.poNumber || request.po_number;
    }

    // Compute amounts — always derive from request data for consistency.
    // Amount Remaining uses Stripe invoice when available (tracks partial/split payments).
    const hasStripeInvoice = invoice && invoice.id;
    const isPaid = hasStripeInvoice && invoice.paid;
    const isDealer = request.requestType === REQUEST_TYPES.DEALER;
    // Single source of truth for the custody gate — see src/util/deliverGate.js.
    // dealer: a real invoice exists (generated or paid). retail: invoice paid.
    // A job the server already moved to 'paid' is settled by definition, so it
    // qualifies even if state.invoice is stale or failed to load — otherwise a
    // paid job could render the unpaid arm and invite a second collection.
    const deliverable = canDeliver(request, invoice, offlineSettlement)
      || request.currentState === REQUEST_STATES.PAID;
    // Terminal (card-reader) progress surfaced inline in the drawer's TenderTiles
    // "Working" area (the PaymentProgressModal is gated off in the tiles flow).
    const TERMINAL_LABELS = {
      initializing: 'Starting…',
      checking_terminal: 'Checking the card reader…',
      creating_intent: 'Preparing payment…',
      sending_to_reader: 'Sending to the card reader…',
      waiting_for_customer: 'Waiting for the customer to tap, insert, or swipe…',
      processing: 'Processing payment…',
    };
    const isTerminalWorking = showSwipe && Object.prototype.hasOwnProperty.call(TERMINAL_LABELS, paymentState);
    const isTerminalError = showSwipe && ['error', 'declined', 'terminal_offline'].includes(paymentState);
    const customerTotal = (request.requestTotal || 0) - (request.requestDiscount || 0) + (request.requestTaxes || 0);
    const depositCredit = parseFloat(request.depositAmount) || 0;
    const amountOwed = customerTotal.toFixed(2);
    // Settled offline: the money landed but no Stripe invoice exists yet, so the
    // usual fallback would show the FULL total as still owed next to a Deliver
    // button. Nothing is remaining — the invoice is what's outstanding, not the cash.
    const settledOffline = isSettledOffline(offlineSettlement);
    // Retail: remainingBalance is the same figure the drawer charges against
    // (GET /invoices/:id/balance, falling back to total − deposit − splits). Stripe's
    // own amount_remaining does not see cash/check split payments, so reading it
    // here showed the full balance until the drawer was opened. Dealer jobs never
    // load split history, so they keep reading the Stripe invoice.
    const amountRemaining = settledOffline
      ? '0.00'
      : hasStripeInvoice
        ? (invoice.paid
            ? '0.00'
            : isDealer
              ? (invoice.amount_remaining / 100).toFixed(2)
              : (parseFloat(remainingBalance) || 0).toFixed(2))
        : (customerTotal - depositCredit).toFixed(2);
    // FRAUD GUARD. Once the job has been settled, it stops being editable or
    // deletable. Without this, the path is: raise a request, collect the cash,
    // delete the record — the payment row orphaned, the job gone, and nothing
    // left to reconcile against. Deliver is the only remaining action.
    //
    // DEPOSITS ARE DELIBERATELY EXCLUDED. A deposit is a commitment against work
    // not yet done, not settlement of the job. A deposit-only job must stay
    // correctable — scope changes before the work starts are normal, and locking
    // it would break a legitimate workflow to guard a risk that isn't there.
    //
    // Split payments toward the FINAL invoice do count: that is money taken on
    // this job, deleting it would orphan the rows, and the retail Edit button
    // already treated them as blocking — so including them preserves existing
    // behaviour rather than loosening it.
    const moneyCollected = settledOffline || isPaid || collectedPayments.length > 0;

    // Bundled/included takeaway products on a service (is_bundle material tasks).
    // Surfaced on the ticket as a $0 "Includes …" reminder so the checkout user
    // hands the product over at payment. Quantity shows in SELL units ("1 bottle")
    // when the task carries packaging (base_units_per_sell_unit + sell unit code);
    // otherwise we show just the product name rather than a confusing base unit.
    const bundledIncludesFor = (s) => {
      const items = (s && s.items) || [];
      return items
        .filter(it => (!it.type || it.type === 'material')
          && (it.is_bundle === 1 || it.is_bundle === true)
          && (it.recommended_product_name || it.actual_product_name))
        .map(it => {
          const name = it.recommended_product_name
            ? formatPrefixedProductLabel(it, 'recommended_product')
            : formatPrefixedProductLabel(it, 'actual_product');
          const factor = parseFloat(it.base_units_per_sell_unit) || null;
          const sellUnit = it.sell_unit_code || it.sell_unit_name || null;
          const expBase = parseFloat(it.expected_qty);
          let qty = '';
          if (factor && factor > 0 && sellUnit && !isNaN(expBase) && expBase > 0) {
            const sellQty = +(expBase / factor).toFixed(2);
            qty = `${sellQty} ${sellUnit}${sellQty === 1 ? '' : 's'} of `;
          }
          return { key: it.id || it.task_id || name, text: `${qty}${name}` };
        });
    };

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <div className="mb-2">
              <AssetIdentifier
                request={request}
                hin={checkinHin}
                fieldKey="vin-finished"
                copiedField={copiedField}
                copyToClipboard={copyToClipboard}
              />
            </div>
            <div className="mb-2">
              Amount Owed : ${amountOwed}
            </div>
            {depositCredit > 0 && (
              <div className="mb-2 text-success">
                Deposit Credit : -${depositCredit.toFixed(2)}
              </div>
            )}
            {/* Payments already taken toward the final invoice (split payments).
                Same rows the drawer counts; voids are excluded upstream. */}
            {collectedPayments.map((p, i) => {
              const amt = parseFloat(p.payment_amount) || parseFloat(p.amount) || parseFloat(p.invoice_amount) || 0;
              const method = (p.payment_method || '').toLowerCase();
              const counted = p.payment_state === 'paid' || (p.payment_state === 'pending' && method === 'cash');
              const label = method ? method.charAt(0).toUpperCase() + method.slice(1) : 'Payment';
              return (
                <div key={p.payment_id || p.id || p.invoice_id || i} className={`mb-2 ${counted ? 'text-success' : 'text-muted'}`}>
                  {label} Payment{collectedPayments.length > 1 ? ` ${i + 1}` : ''} : -${amt.toFixed(2)}{counted ? '' : ' (pending)'}
                </div>
              );
            })}
            {/* Gates on isPaid, not deliverable, on purpose: the PO is about money
                still owed, not about custody. It stays visible on an open invoice. */}
            {request.requestType === REQUEST_TYPES.DEALER && !isPaid && (
              <div className="mb-2">
                PO Received : {PO}
              </div>
            )}
            <div className="mb-3">
              Amount Remaining : ${amountRemaining}
            </div>

            {isInvoiceRecovery && (
              <div className="mb-3 px-2 py-2" style={{ backgroundColor: 'var(--color-warning-light)', borderRadius: 6, fontSize: 13 }}>
                <i className="fa-sharp fa-regular fa-file-invoice mr-2" style={{ color: 'var(--color-warning-dark)' }} />
                {hasStripeInvoice
                  ? 'Replacement invoice sent. This job will move to Financials.'
                  : 'The invoice for this delivered job was voided. Edit the job if needed, then Check Out to create and send the replacement invoice.'}
              </div>
            )}

            {/* Cash and check are settled WITHOUT a Stripe invoice, deliberately —
                that money never moves through Stripe, and QBO is already served by
                a synthetic charge.succeeded (`invoiceController.js:1238`). So a zero
                balance with no invoice is the DESIGNED outcome here, not a failure.
                Nothing is retrying in the background.

                An earlier version of this block said "invoice pending" and claimed
                "the invoice is materialized later by the server's reconcile pass;
                recovery lives in Financials". All three were false: no reconcile
                pass exists, Financials has no recovery surface, and nothing was ever
                pending. That copy was written from a stale server docblock which
                still claims a `stripe_sync_pending` retry flag that exists nowhere
                in either repo. It sent a real investigation down the wrong path —
                request #4178 was reported as a broken invoice when it was working
                exactly as designed.

                What DOES happen: settle-offline raises an `invoice_recovery` task in
                the same transaction, assigned to the owner. Closing it requires a
                resolution_type, which is the audit record for why no invoice exists.
                That task is the recovery surface. */}
            {settledOffline && (
              <div className="mb-3 px-2 py-2" style={{ backgroundColor: 'var(--color-warning-light)', borderRadius: 6, fontSize: 13 }}>
                <i className="fa-sharp fa-regular fa-money-bill-wave mr-2" style={{ color: 'var(--color-warning-dark)' }} />
                Paid by {offlineSettlement.paymentMethod === 'check' ? 'check' : 'cash'}
                {offlineSettlement.checkNumber ? ` #${offlineSettlement.checkNumber}` : ''}
                {' — no invoice is generated for cash or check. A follow-up task has been raised.'}
              </div>
            )}

        {/* Upload completion photos */}
        <div className="jv-btn-group-spaced">
          <ActionButton
            onClick={() => setShowCompletionPhotos(true)}
            className="jv-btn jv-btn-tertiary"
            userAccess={userAccess}
          >
            {isMobile ? 'Take Completion Photos' : 'Upload Completion Photos'}
          </ActionButton>
        </div>

        {/* PAID retail job — nothing left to collect. Stripe emails the customer a
            receipt automatically on payment, so Deliver is the only action. */}
        {(deliverable && request.requestType === REQUEST_TYPES.INSTALLER) && (
          <div className="jv-btn-group-spaced">
            <ActionButton
              onClick={() => onDeliver(request)}
              className="jv-btn jv-btn-primary"
              userAccess={userAccess}
            >
              <i className="fa-sharp fa-regular fa-truck mr-2" />
              Deliver
            </ActionButton>
          </div>
        )}

        {/* UNPAID installer job — unified for draft, Stripe draft, and Stripe open */}
        {(!deliverable && request.requestType === REQUEST_TYPES.INSTALLER) && (
          <div>
            <div className="jv-btn-group-spaced mt-3">
              <ActionButton
                onClick={() => setShowCheckoutDrawer(true)}
                className="jv-btn jv-btn-primary"
                userAccess={userAccess}
              >
                Check Out
              </ActionButton>

              {/* Same fraud guard as the dealer branch — see moneyCollected above.
                  Delete was previously OUTSIDE this condition, so a retail job with
                  collected split payments could be deleted with the money already
                  taken. Both actions are now gated together. */}
              {!moneyCollected && (
                <>
                  <span className="jv-btn-group-divider" />

                  <ActionButton
                    onClick={() => onVoidInvoice(request)}
                    className="jv-btn jv-btn-secondary"
                    userAccess={userAccess}
                  >
                    Edit
                  </ActionButton>

                  <span className="jv-btn-group-divider" />

                  <ActionButton
                    onClick={() => onDelete(request)}
                    className="jv-btn jv-btn-danger"
                    userAccess={userAccess}
                  >
                    Delete
                  </ActionButton>
                </>
              )}
            </div>
          </div>
        )}

        {(request.requestType === REQUEST_TYPES.DEALER) && (
          <div className="jv-btn-group-spaced mt-3">
            {/* Paid dealer job — nothing left to collect, so skip the drawer and
                deliver directly. The drawer's only remaining action would be
                "Deliver & send invoice", and the invoice is already settled.
                Unpaid dealer jobs keep the drawer (collect, then deliver). */}
            {deliverable && isInvoiceRecovery ? (
              /* Already delivered — the replacement invoice is now out. Nothing
                 left to do here; the row leaves Pickups on the next refresh. */
              null
            ) : deliverable ? (
              /* Resend lives on Financials (newFinancials.jsx:698/1901/2004), which is
                 also the only place to find the invoice after delivery. */
              <ActionButton
                onClick={() => onDeliver(request)}
                className="jv-btn jv-btn-primary"
                userAccess={userAccess}
              >
                <i className="fa-sharp fa-regular fa-truck mr-2" />
                Deliver
              </ActionButton>
            ) : (
              <ActionButton
                onClick={() => setShowCheckoutDrawer(true)}
                className="jv-btn jv-btn-primary"
                userAccess={userAccess}
                disabled={isMaterializing}
              >
                Check Out
              </ActionButton>
            )}

            {PO === "Not Yet" && (
              <>
                <span className="jv-btn-group-divider" />
                <ActionButton
                  onClick={() => onAddPO()}
                  className="jv-btn jv-btn-tertiary"
                  userAccess={userAccess}
                >
                  Add PO
                </ActionButton>
              </>
            )}

            {!moneyCollected && (
              <>
                <span className="jv-btn-group-divider" />
                <ActionButton
                  onClick={() => (!hasStripeInvoice ? onEdit(request) : onVoidInvoice(request))}
                  className="jv-btn jv-btn-secondary"
                  userAccess={userAccess}
                >
                  Edit
                </ActionButton>

                <span className="jv-btn-group-divider" />

                <ActionButton
                  onClick={() => onDelete(request)}
                  className="jv-btn jv-btn-danger"
                  userAccess={userAccess}
                >
                  Delete
                </ActionButton>
              </>
            )}
          </div>
        )}

        {/* Checkout Drawer — slide-over home for the FINISHED-state collect path */}
        <CheckoutDrawer
          show={showCheckoutDrawer}
          onHide={() => { setShowCheckoutDrawer(false); setShowDealerCollect(false); if (payOnlineInvoiceId && onPayOnlineDone) onPayOnlineDone(); }}
          title="Check Out"
          subtitle={[request.dealerName, [request.vehicleColor, request.vehicleYear, request.vehicleMake, request.vehicleModel].filter(Boolean).join(' ')].filter(Boolean).join(' · ') || undefined}
        >
          {showProductPicker ? (
            <ProductPicker
              installerId={typeId}
              locationId={request.location_id || request.locationId}
              busyId={addingProductId}
              onAdd={async (product, qty) => {
                if (onAddProductLine) { await onAddProductLine(product, qty); }
                setShowProductPicker(false);
              }}
              onClose={() => setShowProductPicker(false)}
            />
          ) : (
            <React.Fragment>
              <div className="mb-3">
                <div className="text-muted mb-2" style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.5px' }}>TICKET</div>
                {(services || []).map((s, i) => {
                  const desc = s.custom_description || s.description;
                  // Product upsell lines are stored as custom service lines
                  // (service_category 'Custom') — label them "Product" instead.
                  const category = s.product_id ? 'Product' : s.service_category;
                  const name = category ? (desc ? `${category} - ${desc}` : category) : (desc || 'Service');
                  const amt = (parseFloat(s.service_amount) || 0) - (parseFloat(s.service_discount) || 0);
                  const qty = parseInt(s.quantity, 10) || 1;
                  const editable = !!s.product_id && !hasStripeInvoice && (onUpdateProductQty || onRemoveProductLine);
                  const includes = bundledIncludesFor(s);
                  return (
                    <React.Fragment key={s.service_id || i}>
                      <div className="d-flex justify-content-between align-items-center mb-1" style={{ fontSize: 14 }}>
                        <span>{name}</span>
                        {editable ? (
                          <div className="d-flex align-items-center" style={{ gap: 10 }}>
                            <div className="d-flex align-items-center" style={{ gap: 8, border: '1px solid var(--color-border)', borderRadius: 6, padding: '2px 6px' }}>
                              <i className="fa-sharp fa-regular fa-minus" style={{ cursor: 'pointer', color: 'var(--color-text-secondary)', fontSize: 12 }} onClick={() => onUpdateProductQty && onUpdateProductQty(s, qty - 1)} />
                              <span style={{ fontSize: 13, fontWeight: 600 }}>{qty}</span>
                              <i className="fa-sharp fa-regular fa-plus" style={{ cursor: 'pointer', color: 'var(--color-text-secondary)', fontSize: 12 }} onClick={() => onUpdateProductQty && onUpdateProductQty(s, qty + 1)} />
                            </div>
                            <span className="font-weight-bold">${amt.toFixed(2)}</span>
                            <i className="fa-sharp fa-regular fa-xmark" style={{ cursor: 'pointer', color: 'var(--color-text-muted)', fontSize: 14 }} onClick={() => onRemoveProductLine && onRemoveProductLine(s)} />
                          </div>
                        ) : (
                          <span className="font-weight-bold">${amt.toFixed(2)}</span>
                        )}
                      </div>
                      {includes.map(inc => (
                        <div key={inc.key} className="d-flex justify-content-between align-items-center mb-1" style={{ fontSize: 12, color: 'var(--color-text-secondary)', paddingLeft: 12 }}>
                          <span><i className="fa-sharp fa-regular fa-gift mr-1" style={{ color: 'var(--color-brand-teal)' }} />Includes: {inc.text}</span>
                          <span style={{ fontStyle: 'italic' }}>Included</span>
                        </div>
                      ))}
                    </React.Fragment>
                  );
                })}
                {!hasStripeInvoice && onAddProductLine && (
                  <button
                    type="button"
                    className="btn btn-block mt-2 d-flex align-items-center justify-content-center"
                    style={{ border: '1px solid var(--color-border)', borderRadius: 6, color: 'var(--color-brand-teal)', fontSize: 14, fontWeight: 500 }}
                    onClick={() => setShowProductPicker(true)}
                  >
                    <i className="fa-sharp fa-regular fa-plus mr-2" /> Add product
                  </button>
                )}
              </div>

              <div className="border-top pt-3 mb-3">
                <div className="d-flex justify-content-between mb-1" style={{ fontSize: 14 }}>
                  <span className="text-muted">Subtotal</span>
                  <span>${(parseFloat(request.requestTotal) || 0).toFixed(2)}</span>
                </div>
                {request.requestDiscount > 0 && (
                  <div className="d-flex justify-content-between mb-1" style={{ fontSize: 14 }}>
                    <span className="text-muted">Discount</span>
                    <span className="text-success">-${parseFloat(request.requestDiscount).toFixed(2)}</span>
                  </div>
                )}
                {request.requestTaxes > 0 && (
                  <div className="d-flex justify-content-between mb-1" style={{ fontSize: 14 }}>
                    <span className="text-muted">Tax</span>
                    <span>${parseFloat(request.requestTaxes).toFixed(2)}</span>
                  </div>
                )}
                {depositCredit > 0 && (
                  <div className="d-flex justify-content-between mb-1" style={{ fontSize: 14 }}>
                    <span className="text-muted">Deposit credit</span>
                    <span className="text-success">-${depositCredit.toFixed(2)}</span>
                  </div>
                )}
              </div>

              <div className="border-top pt-3">
                {payOnlineInvoiceId ? (
                  <PayOnlinePanel
                    invoiceId={payOnlineInvoiceId}
                    amountDue={remainingBalance}
                    onPaid={onPayOnlinePaid}
                    onDone={onPayOnlineDone}
                  />
                ) : isDealer && !showDealerCollect ? (
                  <div>
                    {/* Check Out settles the money and nothing else. Sending the
                        invoice closes the drawer; Deliver (custody) is a separate
                        action on the panel, now unlocked. */}
                    <ActionButton
                      onClick={async () => {
                        const sent = await onSendDealerInvoice();
                        if (sent) setShowCheckoutDrawer(false);
                      }}
                      className="jv-btn jv-btn-primary btn-block"
                      userAccess={userAccess}
                      disabled={isMaterializing}
                    >
                      {/* Creating + finalizing the Stripe invoice takes ~2.5s in
                          practice. Without a busy label the button just greys out
                          and reads as broken for long enough to matter. */}
                      {isMaterializing ? (
                        <>
                          <i className="fa-sharp fa-regular fa-spinner fa-spin mr-2" />
                          Sending invoice…
                        </>
                      ) : (
                        <>
                          <i className="fa-sharp fa-regular fa-paper-plane mr-2" />
                          Send invoice
                        </>
                      )}
                    </ActionButton>
                    <button
                      type="button"
                      className="btn btn-link btn-block btn-sm mt-2"
                      onClick={() => setShowDealerCollect(true)}
                    >
                      Take payment now
                    </button>
                  </div>
                ) : (
                  <TenderTiles
                    amountDue={remainingBalance}
                    collectedPayments={collectedPayments}
                    processing={isMaterializing || isProcessingSplitPayment || isTerminalWorking}
                    error={splitPaymentError || (isTerminalError ? paymentError : null)}
                    workingLabel={
                      isConfirmingSplitPayment
                        ? 'Confirming payment…'
                        : (isTerminalWorking ? TERMINAL_LABELS[paymentState] : null)
                    }
                    onCancel={isTerminalWorking ? () => { onCancelTerminal(); if (closeSwipe) closeSwipe(); } : null}
                    allowPartial={!isDealer}
                    onCollect={onCollect}
                  />
                )}
              </div>
            </React.Fragment>
          )}
        </CheckoutDrawer>

        {/* Online Invoice Link Modal */}
        {showInvoiceLinkModal && (
          <Modal show={showInvoiceLinkModal} onHide={onCloseInvoiceLinkModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Online Payment Invoice Created</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>The invoice has been created and sent to the customer's email.</p>
              <p>You can also share this payment link:</p>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  value={currentInvoiceLink}
                  readOnly
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      navigator.clipboard.writeText(currentInvoiceLink);
                      alert('Link copied to clipboard!');
                    }}
                  >
                    Copy
                  </button>
                </div>
              </div>
              <p className="mt-3 text-muted">
                <small>Close this modal to refresh and see the payment status.</small>
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={onCloseInvoiceLinkModal}>
                Close & Refresh
              </Button>
            </Modal.Footer>
          </Modal>
        )}

          </div>
        </div>

        {selectedPay === "SWIPE CARD" && showSwipe && (
        <PaymentProgressModal
          show={showSwipe}
          onClose={closeSwipe}
          paymentState={paymentState}
          paymentError={paymentError}
          invoice={invoice}
          installer={installer}
          onRetry={onRetryPayment}
          onCancel={onCancelTerminal}
        />
      )}

        {showPO && (
          <AddPO
            show={showPO}
            onClose={closePO}
            type={"dealer"}
            requestId={request.requestId}
            invoiceId={hasStripeInvoice ? invoice.id : null}
            poNumber={PO}
            onPO={onPO}
            onInvoice={onSettle}
          />
        )}

        {showCompletionPhotos && (
          <CompletionPhotosModal
            show={showCompletionPhotos}
            onHide={() => setShowCompletionPhotos(false)}
            requestId={request.requestId}
            onSuccess={handleCompletionPhotosSuccess}
          />
        )}
      </React.Fragment>
    );
  }

  return null;
};

export default RequestimateState;